import { Block } from 'baseui/block';

import { IFG_Setpoint } from './types';

import { LoadingView } from "../../../components";
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper';
import { SmallPanel as SetpointPanel } from '../../Functions/AnalogSetpoint/SmallPanel';
import { SmallPanel } from '../../Functions/Scheduler'

import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';

import { useStyletron } from 'baseui';
import { WiBarometer, WiHumidity, WiThermometer } from "react-icons/wi";



export function OverviewPanel(props: IFG_Setpoint) {
    const [, theme] = useStyletron();
    const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)

    const setpoint = children?.find((v: any) => v.schema === "AutomationApps.Functions.SetPoints.AnalogSetpoint");
    const temperature = children?.find((v: any) => v.schema === "AutomationApps.Functions.SetPoints.TemperatureSetpoint");
    const humidity = children?.find((v: any) => v.schema === "AutomationApps.Functions.SetPoints.HumiditySetpoint");
    const supplypressure = children?.find((v: any) => v.schema === "AutomationApps.Functions.SetPoints.SupplyPressureSetpoint");
    const exhaustpressure = children?.find((v: any) => v.schema === "AutomationApps.Functions.SetPoints.ExhaustPressureSetpoint");


    return (
        <OverviewPanelWrapper {...props}>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>

                <Block display='flex' flexDirection='column' alignItems='center' justifyContent='center' gridGap='25px'>
                {children?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.Functions.SetPoints.DigitalSetpoint") ?
                            (
                                <SetpointPanel key={item.id} {...item}></SetpointPanel>
                            )
                            : (<></>)
                    ))}
                    {children?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.Functions.SetPoints.AnalogSetpoint") ?
                            (
                                <SetpointPanel key={item.id} {...item}></SetpointPanel>
                            )
                            : (<></>)
                    ))}
                    {children?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.Functions.SetPoints.TemperatureSetpoint") ?
                            (
                                <SetpointPanel key={item.id} {...item}></SetpointPanel>
                            )
                            : (<></>)
                    ))}
                    {children?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.Functions.SetPoints.HumiditySetpoint") ?
                            (
                                <SetpointPanel key={item.id} {...item}></SetpointPanel>
                            )
                            : (<></>)
                    ))}
                    {children?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.Functions.SetPoints.SupplyPressureSetpoint") ?
                            (
                                <SetpointPanel key={item.id} {...item}></SetpointPanel>
                            )
                            : (<></>)
                    ))}
                    {children?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.Functions.SetPoints.ExhaustPressureSetpoint") ?
                            (
                                <SetpointPanel key={item.id} {...item}></SetpointPanel>
                            )
                            : (<></>)
                    ))}
                    {children?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.Functions.Schedules.Scheduler") ?
                            (
                                <SetpointPanel key={item.id} {...item}></SetpointPanel>
                            )
                            : (<></>)
                    ))}
                </Block>

            </LoadingView>
        </OverviewPanelWrapper>
    );
}